/** A date in a source name is a hint; saved training_date remains authoritative. */
export const inferTrainingDate = (name: string): string | null => {
  const dates = new Set<string>();
  const expression = /(?:^|[^\d])(\d{2})\.(\d{2})\.(\d{4}|\d{2})(?!\d)/g;
  let match: RegExpExecArray | null;
  while ((match = expression.exec(name))) {
    const day = Number(match[1]);
    const month = Number(match[2]);
    const year = match[3].length === 2 ? 2000 + Number(match[3]) : Number(match[3]);
    if (year < 1000 || month < 1 || month > 12 || day < 1 || day > 31) continue;
    const date = new Date(Date.UTC(year, month - 1, day));
    if (date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day) {
      dates.add(`${year}-${match[2]}-${match[1]}`);
    }
  }
  // Multiple distinct dates need an explicit choice from the administrator.
  return dates.size === 1 ? Array.from(dates)[0] : null;
};

export const formatTrainingDate = (value?: string | null): string => {
  const match = value?.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  return match ? `${match[3]}.${match[2]}.${match[1]}` : 'Не указана';
};

export const formatUploadDate = (value: string): string => {
  // The API stores naive UTC timestamps. Specify UTC before displaying Moscow time.
  const normalized = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(value) ? value : `${value.replace(' ', 'T')}Z`;
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? 'Не указана' : date.toLocaleString('ru-RU', {
    timeZone: 'Europe/Moscow', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit',
  });
};

export const dateMismatchMessage = (trainingDate: string | null | undefined, sourceName: string): string | null => {
  const sourceDate = inferTrainingDate(sourceName);
  if (!sourceDate || sourceDate === trainingDate) return null;
  return trainingDate
    ? `Дата в названии ${formatTrainingDate(sourceDate)} отличается от даты обучения ${formatTrainingDate(trainingDate)}. Проверьте дату перед сохранением.`
    : `В названии указано ${formatTrainingDate(sourceDate)}, а дата обучения не заполнена.`;
};
